// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","banner":"_4uzl4","content":"_1O3Eh","bannerPicture":"_1pahC","bannerTitle":"_2qTDx","bannerDescription":"rHYAs"};